// actions.ts - Fixed version
import { adminLogin } from "../../../helpers/backend_helper";
import { loginError, loginSuccess, logoutSuccess } from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import { setAuthorization } from "helpers/api_helper";

interface User {
    username?: string;
    password: string;
}

export const loginUser = (
    user: User,
    history: any
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {

        if (!user.username || !user.password) {
            const errorMsg = "Email/Username and password are required";
            dispatch(loginError(errorMsg));
            throw new Error(errorMsg);
        }
        const loginData = { username: user.username, password: user.password };
        const response = await adminLogin(loginData);

        console.log("Full API Response:", response);
        if (!response) {
            const errorMsg = "No response from server";
            dispatch(loginError(errorMsg));
            throw new Error(errorMsg);
        }

        const isSuccess = (response as any)?.message === "Login successful" || (response as any)?.token;

        if (!isSuccess) {
            const errorMsg = (response as any)?.message || "Login failed";
            dispatch(loginError(errorMsg));
            throw new Error(errorMsg);
        }
        const userData = response;
        localStorage.setItem("authUser", JSON.stringify(userData));
        setAuthorization((response as any)?.token)
        console.log((response as any)?.token);
        dispatch(loginSuccess(userData));
        history("/dashbordNew");

    } catch (error: any) {
        console.error("Login error:", error);
        let errorMsg = "Invalid Credentials";
        dispatch(loginError(errorMsg));
        throw new Error(errorMsg);
    }
};

















export const logoutUser = () => async (dispatch: Dispatch) => {
    try {
        localStorage.removeItem("authUser");
        sessionStorage.removeItem("authUser");

    } catch (error: any) {
        console.error("Logout error:", error);
        dispatch(loginError(error.message || "Logout failed"));
    }
}

export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
    try {
        let response: any;



    } catch (error: any) {
        console.error("Social login error:", error);
        dispatch(loginError(error.message || "Social login failed"));
    }
}
